import React from "react";
import { AdSenseUnit, AD_SLOTS } from "./AdSenseUnit";

// Multiplex banner shown while a conversion (Excel/Word) or Excel analysis is
// being processed. Slot: "Banner multiplo".
export const LoadingAd = () => {
  return (
    <div data-testid="loading-multiplex-ad" className="mx-auto mt-8 w-full max-w-2xl">
      <span className="mb-1 block text-center text-[10px] font-medium uppercase tracking-wider text-slate-400">
        Annuncio
      </span>
      <div className="min-h-[250px] overflow-hidden rounded-2xl border border-slate-200 bg-white p-2">
        <AdSenseUnit
          testId="loading-multiplex-ad-unit"
          slot={AD_SLOTS.multiplex}
          format="autorelaxed"
        />
      </div>
    </div>
  );
};
